import React from 'react';
import img1 from '../../../../assets/home-imgs/story-img.png';
import bgImg from '../../../../assets/logos/frame-1.svg';
import './Story.css';

const Story = () => {
    return (
        <div className='lg:mt-20 mt-12'>
            <div className='lg:mx-20'>
                <h2 className='story-h2 my-5'>Our Story</h2>
                <div className='flex'>
                    <div className='w-[1600px]'>
                        <div className=''>
                            <h1 className='story-h1 lx:mx-0 mx-2'>Khukumoni Foundation</h1>
                            <p className='story-p mt-5 lx:mx-0 mx-7'><span className='story-span'>Khukumoni Foundations </span> 
                            
                            is a non-profit humanitarian and educational support organization dedicated to empowering vulnerable and underprivileged communities through education, nutrition, healthcare, humanitarian relief, and sustainable development initiatives. We believe every child and every human being deserves dignity, opportunity, hope, and the chance to build a better future.
                            
  
                                <br />
                                <br />
                                <span className='story-span'>Khukumoni Foundation</span> founded in 2016 by a group of passionate volunteers at Suhrawardy Udyan, Dhaka. It began its journey with a commitment to supporting disadvantaged street children through education and social development programs. Under the leadership of our Chairman,  <span className='story-span'>MD AL MANSUR RAHMAN —</span> a visionary social activist and humanitarian — the organization has grown into a recognized charitable foundation driven by compassion, integrity, and community service.
                                <br />
                                <br />

                                Over the years, <span className='story-span'>Khukumoni Foundations </span>  has expanded from educational support initiatives to humanitarian and social welfare programs for vulnerable children and families affected by poverty, hunger, disasters, conflict, and social injustice.
                                <br />
                                <br />
                                Today, <span className='story-span'>Khukumoni Foundations </span> continues its journey with a global humanitarian perspective, working to support communities in need and inspire positive social change through compassion, unity, and action.</p>
                        </div>
                    </div>
                    <div className='story-sm-responsive'>
                        <div>
                            <div className='mt-[450px] w-96'>
                                <img src={bgImg} alt="" className='ml-20' />
                            </div>
                            <div className='absolute -mt-[470px] w-96'>
                                <img src={img1} alt="" className='ml-16' />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='bg-[#24316B] w-full h-12 relative -mt-6'></div>
        </div>
    );
};

export default Story;